import { render, staticRenderFns } from "./TreeModel.vue?vue&type=template&id=09cbe22e"
import script from "./TreeModel.vue?vue&type=script&lang=js"
export * from "./TreeModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports